import { CartAddEvent } from '@theme/events';

/**
 * Bridges JOIN Stories' "Add to cart" CTA to the theme's cart so the drawer,
 * cart bubble and cart items all refresh the same way a native add-to-cart does.
 * @see https://docs.join-stories.com/docs/add-to-cart-javascript
 */
document.addEventListener('JOIN_STORIES_ADD_TO_CART', async (event) => {
  const { orderId, productId, variantId } = event.detail || {};

  const resolve = (errorOrTrue) => {
    if (typeof window.JoinStories?.resolveAddToCart === 'function') {
      window.JoinStories.resolveAddToCart(orderId, errorOrTrue);
    }
  };

  if (!orderId) return;

  if (!variantId) {
    resolve(true);
    return;
  }

  try {
    const cartAddUrl = window.theme?.routes?.cart_add_url || '/cart/add.js';

    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      const isOutOfStock = /sold out|out of stock|épuisé|rupture/i.test(`${data.message} ${data.description}`);
      resolve(isOutOfStock ? 'PRODUCT_OUT_OF_STOCK' : true);
      return;
    }

    document.dispatchEvent(
      new CartAddEvent(data, `join-stories-${orderId}`, {
        source: 'join-stories',
        itemCount: data.quantity,
        productId: productId ? String(productId) : undefined,
        variantId: String(variantId),
      })
    );

    resolve();
  } catch (error) {
    console.error('JOIN Stories: add to cart failed', error);
    resolve(true);
  }
});
